<template>
    <div class="layer-contents" ref="layerContents">
        <div class="layer-img media-wrap">
            <!-- 우측 미디어 박스 -->
            <right-video-view
                v-if="viewMedia.media_type_name == '동영상' "
                :media-thumbnail-url=" viewMedia.image_full "
                :media-thumbnail2-url=" viewMedia.image_medium "
                :media-path=" viewMedia.media_path "
                :key="viewMedia.id"
            ></right-video-view>
            <right-audio-view
                v-else-if="viewMedia.media_type_name == '오디오' "
                :media-thumbnail-url=" viewMedia.image_full  "
                :media-thumbnail2-url=" viewMedia.image_medium "
                :media-path=" viewMedia.media_path "
            ></right-audio-view>
            <right-image-view
                v-else
                :main-url=" viewMedia.image_full  "
                :sub-url=" viewMedia.image_medium "
            ></right-image-view>

            <!-- 팝업 좌측 -->
            <div class="media-explanation">
                <!-- 현재 미디어 정보 -->
                <explanation-head
                    :media="viewMedia"
                    @explanation-head-height="setExplanationHeadHeight"
                ></explanation-head>
                <!-- 하단 리스트 -->
                <div class="explanation-body">
                    <div class="tabArea">
                        <ul class="tabs">
                            <li :class="{active: selectedTab=='group'}">
                                <a href="#" @click.prevent="chageActiveTab('group')">연속자료</a>
                            </li>
                            <li :class="{active: selectedTab=='similar'}" v-if="mediaType=='이미지'">
                                <a href="#" @click.prevent="chageActiveTab('similar')">유사자료</a>
                            </li>
                            <li :class="{active: selectedTab=='caption'}" v-else>
                                <a href="#" @click.prevent="chageActiveTab('caption')">자막</a>
                            </li>
                        </ul>
                        <!-- 연속자료 탭내용 -->
                        
                        <group-media-list
                            v-if="explanationHeadHeight>0"
                            :head-height="explanationHeadHeight"
                            :active-group-media=" selectedTab=='group' "
                            :group-list="groupMediaList"
                            @select-media="selectMedia"
                            :view-media="viewMedia"
                            :is-data-loading="isDataLoading"
                        ></group-media-list>
                        <!-- 유사자료 탭내용 -->
                        <div class="tabContent" :class="{active: selectedTab=='similar'}" v-if="mediaType=='이미지'">
                            <similar-media-list v-if=" similarMediaCount>0 "
                                :similar-list="SimilarMediaList"
                                @select-media="selectMedia"
                                :is-data-loading="isDataLoading"
                            ></similar-media-list>
                        </div>
                        <!-- 자막 탭내용 -->
                        <div class="tabContent" :class="{active: selectedTab=='caption'}" v-else>
                            <div class="yScroll" style="max-height: 100%;">
                                <vue-custom-scrollbar class="ps">
                                    <div class="subtitles">
                                        {{ isNotEmpty(viewMedia.caption)?viewMedia.caption:"(자막 없음)" }}
                                    </div>
                                </vue-custom-scrollbar>
                            </div> 
                        </div>
                    </div>
                </div>
            </div><!-- //media-explanation -->
        </div><!-- //media-wrap -->
        
    </div><!-- //layer-contents -->
</template>

<script>
import VueCustomScrollbar from 'vue-custom-scrollbar'; // 스크롤바 옵션 https://binaryify.github.io/vue-custom-scrollbar/en/#options
// import ImageTypeMediaBox from './ImageTypeMediaBox.vue';
import RightImageView from './RightBox/ImageView.vue';
import RightVideoView from './RightBox/VideoView.vue';
import RightAudioView from './RightBox/AudioView.vue';
import ExplanationHead from './ExplanationHead.vue';
import GroupMediaList from './GroupMediaList.vue';
import SimilarMediaList from './SimilarMediaList.vue';

export default {
    components: {
        VueCustomScrollbar, // <vue-custom-scrollbar>
        // right compos
        RightVideoView, RightAudioView, RightImageView,
        // left compos
        ExplanationHead,
        GroupMediaList,
        SimilarMediaList, // <similar-media-list>
    },
    props: {
        theme: { type: String , default: "folkplay" }, // TODO 기본 테마?
        initMedia: { type: Object, require: true, }, // 선택된 미디어
        initGroupList: { type: Array|Object, }, // 연속자료 목록 + 유사자료 목록
    },
    data() {
        return {
            viewMedia: null, // 상세히 볼 미디어
            selectedTab: 'group',
            isDataLoading: true,
            isImageInStoryType: false,
            explanationHeadHeight: 0,
            groupMediaCount: 0,
            groupMediaList: [],
            similarMediaCount: 0,
            SimilarMediaList: [],
        }
    },
    created(){
        // console.log(this.viewMedia);
        this.viewMedia = this.initMedia; // 선택 멀티미디어 정보 초기화
        // TODO 초기 데이터 정보 검즘
        if(this.isNotEmpty(this.initGroupList)){
            this.groupMediaCount = this.initGroupList.length;
            this.groupMediaList = this.initGroupList;
        }
        // 스토리 아이템 번호가 있는 경우 (==이야기자료 상세보기 하단에서 온 경우)
        if( window._.has(this.viewMedia, 'storyId') ) {
            this.getSimilarData(this.viewMedia.storyId);
        } else { // 없으면 (==멀티미디어 목록에서 온 경우)
            this.getRelatedAndSimilarData();
        }
        this.mediaType = this.isNotEmpty(this.viewMedia.media_type_name)?this.viewMedia.media_type_name:"Unknwon";
    },
    methods: {
        // 탭 변경
        chageActiveTab(type) {
            this.selectedTab = type;
        },
        // 연속/유사자료에서 미디어 선택
        selectMedia(media) {
            // console.log(media);
            this.viewMedia = media;
        },
        // 연관자료 가져오기 통신
        getRelatedAndSimilarData() {
            // console.log("getRelatedData()", mediaId, this.theme);
            let ajaxCount = 0;
            let url = `/api/v1/multimedia/related?multimedia_id=${this.viewMedia.multimedia_id}&theme=${this.theme}`;
            // API 통신 시작
            this.isDataLoading = true;
            axios({ method: 'GET', url}).then(({data}) => {
                // console.log(data);
                if( data.count < 1) data = { count: 1, media_list: [ this.viewMedia ] }; // 결과가 없으면 보여지고 있는 미디어 반환
                this.groupMediaList = data.media_list;
                this.groupMediaCount = data.count;
            }).catch(err => {
                console.log(err);
            }).finally(()=>{
                // 이어서 유사자료 가져오기 통신
                url = `/api/v1/multimedia/similar?multimedia_id=${this.viewMedia.id}&theme=${this.theme}`;
                axios({ method: 'GET', url}).then(({data}) => {
                    // console.log(data);
                    if( data.count < 1) data = { count: 1, media_list: [ this.viewMedia ] }; // 결과가 없으면 보여지고 있는 미디어 반환
                    this.SimilarMediaList = data.media_list;
                    this.similarMediaCount = data.count;
                }).catch(err => {
                    console.log(err);
                }).finally(()=>{
                    this.isDataLoading = false;
                });
            });
        },
        // 유사자료 가져오기 통신
        getSimilarData(storyId) {
            const url = `/api/v1/story/${storyId}/multimedia/similar`;
            // API 통신 시작
            this.isDataLoading = true;
            axios({ method: 'GET', url}).then(({data}) => {
                // console.log(data);
                this.SimilarMediaList = data.media_list;
                this.similarMediaCount = data.count;
            }).catch(err => {
                console.log(err);
            }).finally(()=>{
                this.isDataLoading = false;
            });
        },
        // 좌상단 정보박스 높이
        setExplanationHeadHeight(h){
            this.explanationHeadHeight = h;
        },
    },
}
</script>